import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import type { CentralMappingMenuView } from 'lumen/controllers/hotel/settings/central-mapping/menu';
import type { Transition as TransitionWithTo } from 'lumen/services/transition';

export type HotelSettingsCentralMappingMenuParams = {
  view: CentralMappingMenuView;
};

export default class HotelSettingsCentralMappingMenuRoute extends Route {
  queryParams = {
    view: {
      refreshModel: false,
    },
  };

  @service declare transition: Services['transition'];

  beforeModel(transition: TransitionWithTo): void {
    this.transition.validateCentralMappingMenuQueryParams(
      transition,
      this.paramsFor(this.routeName) as HotelSettingsCentralMappingMenuParams, // Use paramsFor to obtain the deserialised query params
    );
  }
}
